module.exports = __webpack_public_path__ + "static/img/icon-statisticaldata.949448cd.svg";